import { useState, useEffect } from 'preact/hooks';
import { getSizedImageUrl } from '../../core/shopify/get-sized-image-url';
const SRCSET_WIDTHS = [
    300,
    600,
    1000
];
export const useGiftboxImage = ({ giftboxKey , giftboxProducts , diyGiftboxProducts , defaultImage =null , defaultAlt =''  })=>{
    const [src, setSrc] = useState(defaultImage);
    const [alt, setAlt] = useState(defaultAlt);
    useEffect(()=>{
        try {
            if (giftboxKey) {
                const product = giftboxProducts && giftboxProducts[giftboxKey] || diyGiftboxProducts && diyGiftboxProducts[giftboxKey] || null;
                if (product) {
                    setSrc(product.featuredImage || product.image || defaultImage);
                    setAlt(product.featuredImageAlt || product.title || '');
                    return;
                }
            }
        } catch (err) {
        // ignore
        }
        setSrc(defaultImage);
        setAlt(defaultAlt);
    }, [
        giftboxKey,
        giftboxProducts,
        diyGiftboxProducts,
        defaultImage,
        defaultAlt
    ]);
    const srcset = src ? SRCSET_WIDTHS.map((w)=>`${getSizedImageUrl(src, `${w}x`)} ${w}w`).join(', ') : undefined;
    return {
        src,
        srcset,
        alt
    };
};
